const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class CivilUnrest extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.CivilUnrest,
            "Each civilization loses 4 culture per discontent worker. All civilizations with the most discontent workers also returns 1 blue token to the box. If no one has discontent workers, this event has no effect.",
            {}
        )
    }
}

module.exports = CivilUnrest;